module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }]
  }, [_c('xi-top'), _vm._v(" "), _c('div', {
    staticClass: "center-container"
  }, [_c('div', {
    staticClass: "top-out-wrapper"
  }, [_c('div', {
    staticClass: "top-bg-wrapper"
  }, [_c('div', {
    staticClass: "top-inner-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.userObj.userPortrait100
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-center-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.userObj.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "authorization"
  }, [_c('span', [_vm._v(_vm._s(_vm.getLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "datas"
  }, [(_vm.userObj.userStatus > 0) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'copyrighterMessage'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.readAllMessage();
        _vm.getNewStatus();
      }
    }
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.unReadMessageCount))]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('word.message')))])]) : _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v("0")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('word.message')))])]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'WriterCenterEvents'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNewStatus();
      }
    }
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.unReadEvent))]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('word.vacate')))])]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'copyrighterAnnouncement'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNewStatus();
      }
    }
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.unReadAnnouncement))]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('word.announcement')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "top-tail-wrapper"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.userObj.userStatus !== 9
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.uploadWork')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-out-wrapper"
  }, [_c('div', {
    staticClass: "content-inner-wrapper"
  }, [_c('div', {
    staticClass: "content-left"
  }, [_c('div', {
    staticClass: "center-works-category"
  }, [_c('router-link', {
    attrs: {
      "active-class": "active",
      "to": {
        name: 'worksManagement'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNewStatus($event)
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-copyright-management va-mid mr10"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('comb.copyrightWorkManagement')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "to": {
        name: 'taskManagementList'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNewStatus($event)
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-task-management va-mid mr10"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('comb.releasedTask')))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/center/tradeRecord",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-earning-detail va-mid mr10"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('comb.earningDetail')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "to": {
        name: 'dataAnalysis'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNewStatus($event)
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-data-analysis va-mid mr10"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('comb.dataAnalysis')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [_c('router-view')], 1)])])]), _vm._v(" "), _c('xi-foot'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "close-on-click-modal": false,
      "custom-class": "announcement-pop",
      "show-close": false,
      "top": "30%"
    },
    model: {
      value: (_vm.showLastAnnouncement),
      callback: function($$v) {
        _vm.showLastAnnouncement = $$v
      },
      expression: "showLastAnnouncement"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('word.announcement')))]), _vm._v(" "), _c('div', {
    staticClass: "announcement",
    slot: "default"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.lastAnnouncement) ? _c('span', [_vm._v(_vm._s(_vm.lastAnnouncement.title))]) : _vm._e()]), _vm._v(" "), (_vm.lastAnnouncement) ? _c('p', [_vm._v(_vm._s(_vm.lastAnnouncement.content))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "pop-button",
    on: {
      "click": _vm.closeAnnouncementPop
    }
  }, [_vm._v(_vm._s(_vm.$t('word.close')))])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "页面跳转",
      "custom-class": "detailDialog",
      "size": "mini"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('span', [_vm._v("为了更好地为您服务，将前往喜配音平台进行后续操作！")]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.cancel')))]), _vm._v(" "), _c('a', {
    staticClass: "agree-btn",
    attrs: {
      "type": "button",
      "target": "_blank",
      "href": _vm.$store.state.DUB_HOST
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("跳转至喜配音")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-94fd2b7c!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/center/Center.vue
// module id = 566
// module chunks = 0